<script>
  import {M} from "../../../external";

  export let onClick;
  export let type;

  let icon = "error_outline";
  let message = M.ERROR;
  let disabled = false;

  $: {
    if (!icon || !type) {
      icon = "error_outline";
      message = M.ERROR;
    }

    switch (type) {
      case "LIST_ADD":
        icon = "person_add";
        message = M.LIST_ADD_GOAL2;
        break;
      case "LIST_REMOVE":
        icon = "person_remove";
        message = M.LIST_REMOVE_GOAL2;
        break;
      case "MEMBER_GROUP_ADD":
        icon = "person_add";
        message = M.MEMBER_GROUP_ADD_GOAL;
        break;
      case "MEMBER_GROUP_REMOVE":
        icon = "person_remove";
        message = M.MEMBER_GROUP_REMOVE_GOAL;
        break;
      case "EMAIL_OPEN":
        icon = "drafts";
        message = M.EMAIL_OPEN_GOAL2;
        break;
      case "EMAIL_CLICK":
        icon = "insert_link";
        message = M.EMAIL_CLICK_GOAL2;
        break;
      case "TAG_ADD":
        icon = "label";
        message = M.TAG_ADD_GOAL2;
        break;
      case "TAG_REMOVE":
        icon = "label_off";
        message = M.TAG_REMOVE_GOAL2;
        break;
      case "PROPERTY_CHANGE":
        icon = "assignment_ind";
        message = M.PROPERTY_CHANGE_GOAL2;
        break;
      case "PURCHASE_MAKE":
        icon = "shopping_basket";
        message = M.PURCHASE_MAKE_GOAL2;
        break;
      case "ORDER_STATUS_CHANGE":
        icon = "local_shipping";
        message = M.ORDER_STATUS_CHANGES;
        break;
      case "CHECK_CART_ABANDON":
        icon = "remove_shopping_cart";
        message = M.CHECK_CART_ABANDON_GOAL2;
        disabled = true;
        break;
      case "PAGE_VISIT":
        icon = "visibility";
        message = M.PAGE_VISIT_GOAL2;
        disabled = true;
        break;
      case "VIDEO_STARTED":
        icon = "play_circle";
        message = M.VIDEO_STARTED;
        break;
      case "VIDEO_COMPLETED":
        icon = "play_circle";
        message = M.VIDEO_COMPLETED_AUT;
        break;
        /*
      case "CIRCLE_ENROLL":
        icon = "add_reaction";
        message = "Enrolled in circle";
        break;
      case "CIRCLE_CONTENT_COMPLETED":
        icon = "add_reaction";
        message = "Completed content in a circle";
        break;*/
      default:
        icon = "error_outline";
        message = M.ERROR;
        break;

    }

  }
</script>
<li>
    <div id="list-add" on:click={onClick} class={"add-automation-rule flex align-center" + (disabled ? " automation-rule-disabled" : "")}>
        <span class="material-icons-outlined circle-automation-icon"> {icon} </span>
        <h5>{message}</h5>
    </div>
</li>
